export default __webpack_public_path__ + "static/agency-banner-bf1fd6461855e37e691014b67a5a5b74.png";